import { ReactComponent as Associations } from '../assets/complex-icons/associations.svg';
import { ReactComponent as BoxFinish } from '../assets/complex-icons/box-finish.svg';
import { ReactComponent as Boxes } from '../assets/complex-icons/boxes.svg';
import { ReactComponent as Chat } from '../assets/complex-icons/complex-chat.svg';
import { ReactComponent as Check } from '../assets/complex-icons/complex-check.svg';
import { ReactComponent as Calendar } from '../assets/complex-icons/complex-calendar.svg';
import { ReactComponent as Computer } from '../assets/complex-icons/computer.svg';
import { ReactComponent as Config } from '../assets/complex-icons/config.svg';
import { ReactComponent as Destination } from '../assets/complex-icons/destination.svg';
import { ReactComponent as DevDom } from '../assets/complex-icons/dev-a-dom.svg';
import { ReactComponent as DevPunto } from '../assets/complex-icons/dev-a-punto.svg';
import { ReactComponent as DevSameday } from '../assets/complex-icons/dev-sameday.svg';
import { ReactComponent as Error } from '../assets/complex-icons/error.svg';
import { ReactComponent as General } from '../assets/complex-icons/general.svg';
import { ReactComponent as HubPoint } from '../assets/complex-icons/hub-point.svg';
import { ReactComponent as InDeposit } from '../assets/complex-icons/in-deposit.svg';
import { ReactComponent as Pending } from '../assets/complex-icons/pending.svg';
import { ReactComponent as Point } from '../assets/complex-icons/point.svg';
import { ReactComponent as StockControl } from '../assets/complex-icons/stock-control.svg';
import { ReactComponent as ThreeBoxes } from '../assets/complex-icons/three-boxes.svg';
import { ReactComponent as Transactions } from '../assets/complex-icons/transactions.svg';
import { ReactComponent as TruckDelivery } from '../assets/complex-icons/truck-delivery.svg';
import { ReactComponent as Warning } from '../assets/complex-icons/warning.svg';

export const icons = {
  associations: Associations,
  'box-finish': BoxFinish,
  boxes: Boxes,
  chat: Chat,
  check: Check,
  calendar: Calendar,
  computer: Computer,
  config: Config,
  destination: Destination,
  'dev-a-dom': DevDom,
  'dev-a-punto': DevPunto,
  'dev-sameday': DevSameday,
  error: Error,
  general: General,
  'in-deposit': InDeposit,
  'hub-point': HubPoint,
  pending: Pending,
  point: Point,
  'stock-control': StockControl,
  'three-boxes': ThreeBoxes,
  transactions: Transactions,
  'truck-delivery': TruckDelivery,
  warning: Warning,
};
